export const SANITY_CONFIG = {
  projectId: import.meta.env.VITE_SANITY_PROJECT_ID || "ch4xqcs2",
  dataset: import.meta.env.VITE_SANITY_DATASET || "production",
  apiVersion: "2024-11-01",
  useCdn: true, // Set to false to prevent caching issues during development or critical updates
  token: import.meta.env.VITE_SANITY_TOKEN,
  perspective: "published",
} as const;
